import type { IEllipsisDropdownItemProps } from "@similarweb/ui-components";
import { StyledDropdownItemWithCheckboxAndWrapping } from "./styles";

type Props = {
    isPrimary?: boolean;
} & IEllipsisDropdownItemProps;

const FilterDropdownItemWithCheckboxAndWrapping = ({ id, ...itemProps }: Props) => {
    return (
        <StyledDropdownItemWithCheckboxAndWrapping
            {...itemProps}
            key={id}
            id={id}
            showCheckBox
        />
    );
};

export default FilterDropdownItemWithCheckboxAndWrapping;
